import { Redirect, generatePath, useLocation } from 'react-router-dom';
import { MYLEARNING_URL_FRAGMENT, LEGACY_MYLEARNING_URL_FRAGMENT } from '../../constants/Navigation';
import { MY_LEARNING_TABS } from './myLearningTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const myLearningTabs = MY_LEARNING_TABS.join('|');
export const MyLearningRoutePath = `${MYLEARNING_URL_FRAGMENT}/:tab(${myLearningTabs})?`;
export const getMyLearningUrl = tab => {
  return generatePath(MyLearningRoutePath, {
    tab
  });
};
export const RedirectToMyLearning = () => {
  const location = useLocation();
  const {
    pathname
  } = location;
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace(LEGACY_MYLEARNING_URL_FRAGMENT, MYLEARNING_URL_FRAGMENT)
    })
  });
};